import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "./ui/alert-dialog";
import { formatJst } from "../lib/date";
import { useLocalization } from "../hooks/useLocalization";

/** Confirms a manual "Run Now" trigger before firing it - shows exactly what will run and
 * when it last ran, so an admin never triggers a job blind. */
export const RunNowDialog = ({ job, open, onOpenChange, onConfirm, running }) => {
  const { t } = useLocalization();
  if (!job) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="run-now-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("systemJobs.runNowTitle", { job: job.label })}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2">
              <p>{job.purpose}</p>
              <p className="text-xs text-gray-500">
                {t("systemJobs.lastRunLabel")}: {job.lastRun ? formatJst(job.lastRun.started_at) : t("systemJobs.never")}
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="run-now-cancel">{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="run-now-confirm"
            disabled={running}
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
          >
            {running ? t("systemJobs.running") : t("systemJobs.runNowConfirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
